jQuery($ => {

  if($('.o-image-gallery')[0]){
    $('.o-image-gallery__gallery').slick({
      slidesToShow: 5,
      arrows: false,
      centerMode: true,
      variableWidth: true,
      arrows: true,
    });
  }

});